import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Split, FirestoreReference, Run, Course, Obstacle } from 'src/app/Classes/schema';
import { Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { AnwService } from 'src/app/Services/ANW/anw.service';

@Component({
  selector: 'app-run',
  templateUrl: './run.component.html',
  styleUrls: ['./run.component.css']
})
export class RunComponent implements OnInit, OnDestroy {
  newSplits: Split[] = [];


  run: FirestoreReference<Run>;
  run$: Subscription;

  course: FirestoreReference<Course>;
  course$: Subscription;

  obstacles: FirestoreReference<Obstacle>[];
  obstacles$: Subscription;

  currentTime: number = 0;
  private lastTime;
  timerRunning: boolean;
  runId: string;
  currentObstacleIndex: number = 0;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private anw: AnwService
  ) { }

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      const courseId = params.get('courseId');
      this.runId = params.get('runId');
      const seasonId = params.get('seasonId');

      this.run$ = this.anw.getRun(this.runId).subscribe(ref => {
        this.run = ref;
      })
      this.run = this.anw.initRun();

      this.course$ = this.anw.getCourse(courseId).subscribe(ref => {
        this.course = ref;
      })
      this.course = this.anw.initCourse();

      this.obstacles$ = this.anw.getObstacles(courseId).subscribe(refs => {
        this.obstacles = refs;
      });
      this.obstacles = this.anw.initObstacles();
    })
    setInterval(() => {
      if (this.timerRunning) {
        this.currentTime = (Date.now() - this.lastTime) / 1000;
      }
    }, 27)
  }

  startRun(e: Event) {
    this.timerRunning = true;
    this.lastTime = e.timeStamp;
    this.newSplits.push(new Split());
    this.initSplit();
  }

  initSplit() {
    this.currentObstacleIndex = this.newSplits.length - 1;
    this.currentSplit().obstacleNumber = 1 + this.currentObstacleIndex;
    this.currentSplit().runId = this.runId;
    this.currentSplit().obstacleId = this.obstacles[this.currentObstacleIndex].id
  }

  currentSplit() {
    return this.newSplits[this.currentObstacleIndex];
  }

  finishObstacle(e: Event) {
    this.currentTime = (e.timeStamp - this.lastTime) / 1000
    this.currentSplit().falls = false;
    this.currentSplit().timeSpent = this.currentTime;
    this.currentSplit().createdAt = new Date();
    if (this.currentObstacleIndex < this.obstacles.length) {
      this.newSplits.push(new Split());
      this.initSplit();
      this.lastTime = e.timeStamp;
    } else {
      this.timerRunning = false;
      this.anw.writeSplits(this.newSplits, this.run)
      .then(() => {
        this.router.navigate(['../../'], { relativeTo: this.route });
      })
    }
  }

  failObstacle(e) {
    this.timerRunning = false;

    this.currentTime = (e.timeStamp - this.lastTime) / 1000;
    this.currentSplit().falls = true;
    this.currentSplit().timeSpent = this.currentTime;
    this.currentSplit().createdAt = new Date();
    this.anw.writeSplits(this.newSplits, this.run)
      .then(() => {
        this.router.navigate(['../../'], { relativeTo: this.route });
      })
  }

  now() {
    return Date.now;
  }

  ngOnDestroy() {
    this.obstacles$.unsubscribe();
    this.course$.unsubscribe();
    this.run$.unsubscribe();
  }
}
